/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Alert object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Alert = {
	started: false,
	stack: [],
	start: function () {
		if (!Alert.started) {
			Alert.started = true;
			
			(function putAlert() {
				if (Alert.stack.length == 0)
					Alert.started = false;
				else {
					var alert = Alert.stack[0];
					$('<div class="alert-fix alert-fix-' + alert.type + '" style="display: flex;align-items: center;" ' + (alert.onClose ? 'onclick="' + alert.onClose + '"' : '') + '>\
						<div class="alert-fix-icon">\
							<span class="glyphicons glyphicons-' + alert.icon + '"></span>\
						</div>\
						<div ' + (alert.link ? 'onclick="window.location.href=\'' + alert.link + '\'" ' : '') + 'class="alert-fix-text">' + alert.text + '</div>\
					</div>').appendTo('#alert-container').show().addClass('animated bounceInRight').click(function () {
						var self = $(this).addClass('animated bounceOutRight');
						setTimeout(function () {
							self.remove();
						}, 500);
					});
					Alert.stack.shift();
					setTimeout(putAlert, 400);
				}
			})();
			
		}
	},
	push: function (alerts) {
		[].push.apply(Alert.stack, alerts);
		Alert.start();
	}
};